var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHello(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delivery Location 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9663 14.0839C26.4893 14.0839 27.0052 14.1351 27.5029 14.2373C27.7639 14.2909 28.0188 14.0981 28.018 13.8319L28.0063 9.95052C28.0063 7.76385 27.2729 5.84385 25.9529 4.52385C24.6863 3.27052 22.9796 2.61719 20.9929 2.61719H20.5405C20.3192 2.61719 20.14 2.79688 20.1405 3.01817L20.1663 13.4572C20.1663 13.7772 20.0063 14.0839 19.7529 14.2705C19.4863 14.4572 19.1529 14.5105 18.8596 14.4172L15.3929 13.2839L11.8996 14.4439C11.8062 14.4705 11.6996 14.4839 11.5929 14.4839C11.3796 14.4839 11.1796 14.4305 11.0062 14.2972C10.7396 14.1105 10.5929 13.8172 10.5929 13.4972L10.5801 3.03003C10.5798 2.80931 10.4008 2.63052 10.18 2.63052H9.72622C5.52622 2.65719 2.71289 5.60385 2.71289 9.99052V10.0172L2.72622 20.6039C2.73956 22.7239 3.39289 24.5372 4.63289 25.8705C5.89956 27.2305 7.67289 27.9505 9.75289 27.9505H9.77956L19.5937 27.9135C19.9181 27.9123 20.1088 27.5436 19.9345 27.27C18.7919 25.4764 18.0596 23.4893 18.0596 21.9905C18.0596 17.6305 21.6063 14.0839 25.9663 14.0839Z",
    fill: "url(#paint0_linear_5584_41772)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0727 11.2857C15.2727 11.219 15.49 11.2177 15.6953 11.2843L18.1593 12.0857L18.1428 3.01647C18.1424 2.7955 17.9628 2.61672 17.7419 2.61719L12.9763 2.62747C12.7555 2.62795 12.5769 2.80716 12.5771 3.02792L12.5874 12.1057L15.0727 11.2857Z",
    fill: "#6AD67D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9694 27.3325C25.0347 26.8445 22.3854 24.3925 22.3854 21.9952C22.3854 20.0245 23.9947 18.4219 25.9694 18.4219C27.9441 18.4219 29.5534 20.0245 29.5534 21.9952C29.5534 24.3925 26.9041 26.8445 25.9694 27.3325ZM25.9694 16.4219C22.8907 16.4219 20.3867 18.9219 20.3867 21.9952C20.3867 25.6259 24.5321 29.3819 25.9694 29.3819C27.4067 29.3819 31.5521 25.6259 31.5521 21.9952C31.5521 18.9219 29.0481 16.4219 25.9694 16.4219Z",
    fill: "#121D25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0072 20.5703C25.2632 20.5703 24.6592 21.1743 24.6592 21.917C24.6592 22.6596 25.2632 23.2636 26.0072 23.2636C26.7525 23.2636 27.3578 22.6596 27.3578 21.917C27.3578 21.1743 26.7525 20.5703 26.0072 20.5703Z",
    fill: "#121D25"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5584_41772",
    x1: 26,
    y1: 4.5,
    x2: -4,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AD67D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AD67D",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHello);
export default __webpack_public_path__ + "static/media/hello.79ee179486d2e81297d88ad74f373b88.svg";
export { ForwardRef as ReactComponent };